import React from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../App';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { classIf } from '../../data/utils/classIf';
import { labels } from '../../data/labels';
import BreadcrumbContextProvider from '../navigation/BreadcrumbContext';
import CategoryBreadcrumb from '../navigation/CategoryBreadcrumb';
import TournamentBreadcrumb from '../navigation/TournamentBreadcrumb';
import { PrematchContext } from '../Prematch';
import { TournamentContext } from './TournamentDataFetcher';

function TournamentNavbar(props) {
    const appContext = React.useContext(AppContext);
    const prematchContext = React.useContext(PrematchContext);
    const tCtx = React.useContext(TournamentContext);
    const categoryPath = [props.categoryUrlPath, props.categoryUrlPathSuffix].join('')
    const relativeCategoryPath = useAbsolutePath(categoryPath,null,props.categoryUrlPathSeo,true); 
    const noFollow = isSeoSettingsNoFollow(props.categoryUrlPathSeoSettings); 

    /* function handleGoBack() {
        prematchContext.openCategory(country);
    } */

    function handleClick(e){
        if (window.blockHistoryChanges()) {
            e.preventDefault();
            prematchContext.openCategory(country);
        }else{
            appContext.setHandleOpenFromPath(true)
        }
    }
    
    const sport = props.data.sportById[props.sportRef];
    const country = sport.categoryById[props.categoryRef];

    return (
        <>
            <nav id="nav-go-back" className="nav-go-back">
                <Link to={encodeURI(relativeCategoryPath) } onClick={handleClick} {...(noFollow ? {rel: 'nofollow'}:{})} >
                    <div className="arrow-container" /* onClick={handleGoBack} */>
                        <div className="arrow arrow-left"></div>
                    </div>
                </Link>
                <div className="title-container">
                    <span className="nav-section-title" id="nav-section-title">
                        <BreadcrumbContextProvider>
                            <CategoryBreadcrumb desc={country.descrizione} categories={sport.categories} selected={props.categoryRef} />
                            <TournamentBreadcrumb desc={props.descrizione} tournaments={country.tournaments} selected={props.id} />
                        </BreadcrumbContextProvider>
                    </span>
                </div>
            </nav>
            <nav className="small-navbar">
                <span className={"small-navbar-item" + classIf(tCtx.section === 'matches', 'selected')} onClick={() => {tCtx.changeSection('matches')}}>{labels['prematch.tournament.navbar.matches']}</span>
                {props.classifica &&
                    <span className={"small-navbar-item" + classIf(tCtx.section === 'league-table', 'selected')} onClick={() => {tCtx.changeSection('league-table')}}>{labels['prematch.tournament.navbar.league_table']}</span>
                }
                {props.outrights.length > 0 &&
                    <span className={"small-navbar-item" + classIf(tCtx.section === 'outrights', 'selected')} onClick={() => {tCtx.changeSection('outrights')}}>{labels['prematch.tournament.navbar.outrights']}</span>
                }
                {/* <span className={"small-navbar-item" + classIf(tCtx.section === 'bet-builder', 'selected')} onClick={() => {tCtx.changeSection('bet-builder')}}>{'Bet builder'}</span> */}
            </nav>
        </>
    );
}

export default TournamentNavbar;